/* global instgrm */

/**
 * Handle throttle of function
 *
 * @param {Function} callback Function to throttle
 * @param {Number} delay Throttle delay
 *
 * @returns {Function} Throttled function
 */
const handleThrottle = (callback, delay) => {
  let timeoutId;
  return () => {
    if (!timeoutId) {
      timeoutId = setTimeout(() => {
        callback();
        timeoutId = null;
      }, delay);
    }
  };
};

/**
 * Update the mast depth custom property based on the mast head height
 *
 * @returns {void}
 */
const handleMastHeadHeight = () => {
  // Get the mast head element
  const mastHead = document.querySelector('#masthead');

  if (!mastHead) {
    return;
  }

  // Define the mast height
  let mastHeadHeight = mastHead.offsetHeight;

  // If the mast has no height, get it's child element's height
  if (mastHeadHeight === 0) {
    const mastInner = mastHead.querySelector('.nav-fixed');
    mastHeadHeight = mastInner.offsetHeight;
  }

  // Update the mast height CSS custom property
  document.documentElement.style.setProperty('--mast-depth', `${mastHeadHeight}px`);
};

// Set the mast head height on page load
window.addEventListener('load', () => {
  handleMastHeadHeight();
});

// Update mast height on window resize
window.addEventListener('resize', handleThrottle(handleMastHeadHeight, 200));

/**
 * Trigger an Instagram embed to load on content injection
 *
 * @param {HTMLElement} container The injected element
 *
 * @return {void}
 */
const triggerInstagramEmbed = (container) => {
  // Check if an embed is present
  const instagramEmbed = container.querySelectorAll('.instagram-media');
  // Trigger the embed loading
  if (instagramEmbed.length) instgrm.Embeds.process();
};

window.triggerInstagramEmbed = triggerInstagramEmbed;
